"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMapmakerContext = exports.MapmakerContextProvider = exports.getClient = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useWindowSize_1 = __importDefault(require("react-use/lib/useWindowSize"));
const client_1 = require("@apollo/client");
const useMapmakerApolloClient_1 = __importDefault(require("./useMapmakerApolloClient"));
const MapmakerApi_1 = require("./MapmakerApi");
const useLiveLocalStorage_1 = __importDefault(require("../lib/hooks/useLiveLocalStorage"));
const useMapmakerModals_1 = require("../components/shared/modals/useMapmakerModals");
const MapmakerContext = (0, react_1.createContext)({});
let clientRef = {
    current: null,
};
function getClient() {
    return clientRef.current;
}
exports.getClient = getClient;
function MapmakerContextProvider({ appConfig, identityId, currentCredentials, children, }) {
    const client = (0, useMapmakerApolloClient_1.default)({
        businessId: appConfig.businessId,
        currentCredentials,
    });
    clientRef.current = client;
    const { width } = (0, useWindowSize_1.default)();
    const [lastLoadedAccount, setLastLoadedAccount] = (0, useLiveLocalStorage_1.default)("mapmaker.lastLoadedAccount");
    /* Loads account details. Note consumers of this should handle the case where the account is empty
    because it hasn't been loaded yet. */
    const { data, refetch: refetchAccountData } = (0, MapmakerApi_1.useGetAccountQuery)({
        client,
        skip: !identityId,
        onCompleted: result => setLastLoadedAccount(result.account),
    });
    const account = (0, react_1.useMemo)(() => {
        if (data === null || data === void 0 ? void 0 : data.account) {
            return data.account;
        }
        else if (lastLoadedAccount) {
            return lastLoadedAccount;
        }
        else {
            return undefined;
        }
    }, [data, lastLoadedAccount]);
    return ((0, jsx_runtime_1.jsx)(client_1.ApolloProvider, Object.assign({ client: client }, { children: (0, jsx_runtime_1.jsx)(MapmakerContext.Provider, Object.assign({ value: {
                appConfig,
                apolloClient: client,
                isMobile: width <= 767,
                identityId,
                account,
                authenticatedAccount: (account === null || account === void 0 ? void 0 : account.__typename) === "MapmakerAuthenticatedAccount"
                    ? account
                    : undefined,
                refetchAccountData,
                currentCredentials,
            } }, { children: (0, jsx_runtime_1.jsx)(useMapmakerModals_1.MapmakerModalProvider, { children: children }) })) })));
}
exports.MapmakerContextProvider = MapmakerContextProvider;
function useMapmakerContext() {
    return (0, react_1.useContext)(MapmakerContext);
}
exports.useMapmakerContext = useMapmakerContext;
//# sourceMappingURL=data:application/json;base64,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